import { EMPTY_STRING } from '../../../../../../constants/common'

export const APPLICANT_DOCUMENT_REJECT_FIELD_NAME = 'rejected_reason'

export const APPLICANT_DOCUMENT_REJECT_INITIAL_VALUES = {
  [APPLICANT_DOCUMENT_REJECT_FIELD_NAME]: EMPTY_STRING,
}

export const APPLICANT_DOCUMENT_REJECT_FIELD_MIN_ROWS = 3
